import { createStore, applyMiddleware, Store } from "redux";
import { persistStore, persistReducer, createTransform, Persistor } from "redux-persist";
import { routerMiddleware } from "connected-react-router";
import thunk from "redux-thunk";
import logger from "redux-logger";
import localForage from "localforage";
import createRootReducer, { RootState } from "./../reducers";
import { History } from "history";
import { composeWithDevTools } from "redux-devtools-extension";
import LogRocket from "logrocket";
import ChatSocketManager from "../libs/chatSocketManager";
import omit from "ramda/es/omit";

localForage.config({
	name: "player",
	version: 1.0,
	storeName: "values",
	description: "Player DB",
});

const blacklistTransform = createTransform((inboundState: RootState, key: string) => {
	if (key === "auth") {
		return omit(["loggingOut"], inboundState);
	} else {
		return inboundState;
	}
});

const persistConfig = (key: string) => {
	return {
		key,
		storage: localForage,
		whitelist: ["auth", "profile", "locations", "me", "clubPlayerCounts", "timezones", "ipLocation"],
		transforms: [blacklistTransform],
	};
};

const configureStore = (
	history: History,
	chatSocketManager: ChatSocketManager,
	key: string
): { store: Store<any>; persistor: Persistor } => {
	let middleware = [routerMiddleware(history), thunk, chatSocketManager.chatMiddleware];

	if (process.env.NODE_ENV === "development" && process.env.REACT_APP_LOG_REDUX === "1") {
		middleware.push(logger);
	}

	if (process.env.NODE_ENV !== "development") {
		middleware.push(LogRocket.reduxMiddleware());
	}

	const persistedReducer = persistReducer(persistConfig(key), createRootReducer(history));

	const store = createStore(persistedReducer, undefined, composeWithDevTools(applyMiddleware(...middleware)));

	const persistor = persistStore(store);

	/*
	if (process.env.NODE_ENV !== "production") {
		interface ICustomModule extends NodeModule {
			hot?: any;
		}
		const myModule: ICustomModule = module;

		if (myModule.hot) {
			myModule.hot.accept("./../reducers", () => {
				store.replaceReducer(createRootReducer(history))
				//store.replaceReducer(persistedReducer);
			});
		}
	}
	*/
	return { store, persistor };
};

export default configureStore;
